/***
 *
 *   ACCOUNT NAV
 *   Acount sub nav that renders different options based
 *   on user permissions. Shows billing & user admin to only account owners
 *
 **********/

import { useTranslate } from '@tolgee/react'
import { SubNav } from 'components/lib'

export function AccountNav(props) {
  const { t } = useTranslate()

  return (
    <SubNav
      items={[
        { link: '/account/profile', label: t('red-parrot-profile', 'Profile') },
        { link: '/account/password', label: t('red-parrot-password', 'Password') },
        { link: '/account/2fa', label: t('red-parrot-2fa', '2 factor authentication') },
        // {
        //   link: '/account/billing',
        //   label: 'Billing',
        //   permission: 'owner',
        // },
        // {
        //   link: '/account/apikeys/',
        //   label: 'API Keys',
        //   permission: 'developer',
        // },
        // { link: '/account/users', label: 'Users', permission: 'admin' },
      ]}
    />
  )
}
